namespace $.$$ {
	export class $shm_file_drop extends $.$shm_file_drop {
		native_click( next?: Event ) {
			next?.stopPropagation()
			return next ?? null
		}

		click( next?: Event ) {
			const input = this.Native().dom_node() as HTMLInputElement
			if( next && next.target !== input ) input.click()
			return next ?? null
		}

		drop_title() {
			return this.drag_active() ? 'Отпустите для загрузки' : 'Перетащите файл'
		}

		drag_files( event: DragEvent ) {
			return Array.from( event.dataTransfer?.types ?? [] ).includes( 'Files' )
		}

		@ $mol_action
		drag_enter( next?: DragEvent ) {
			if( !next || !this.drag_files( next ) ) return next ?? null
			next.preventDefault()
			this.drag_active( true )
			return next
		}

		@ $mol_action
		drag_over( next?: DragEvent ) {
			if( !next || !this.drag_files( next ) ) return next ?? null
			next.preventDefault()
			if( next.dataTransfer ) next.dataTransfer.dropEffect = 'copy'
			this.drag_active( true )
			return next
		}

		@ $mol_action
		drag_leave( next?: DragEvent ) {
			if( !next || !this.drag_active() ) return next ?? null
			const node = this.dom_node()
			const target = next.relatedTarget
			if( target instanceof Node && node.contains( target ) ) return next
			this.drag_active( false )
			return next
		}

		@ $mol_action
		file_drop( next?: DragEvent ) {
			if( !next ) return null
			next.preventDefault()
			this.drag_active( false )
			const files = [ ... ( next.dataTransfer?.files ?? [] ) ]
			if( files.length ) this.files( files.slice( 0, 1 ) )
			return next
		}
	}
}
